import { polotnoTypes } from '@/pages/AdvancedEditor/types';
import { ElementType, GroupElementType } from 'polotno/model/group-model';

export const checkPolotnoType = (element: ElementType | undefined, type: polotnoTypes | polotnoTypes[]) => {
    if (!element) {
        return false;
    }

    const elementType = getType(element);

    if (Array.isArray(type)) {
        return type.includes(elementType);
    }

    return elementType === type;
};

export const checkIsAvatarOrAvatarGroup = (element: ElementType | undefined) => {
    if (!element) {
        return false;
    }

    if (checkPolotnoType(element, [polotnoTypes.Avatar])) {
        return true;
    }

    if (
        checkPolotnoType(element, [polotnoTypes.Group]) &&
        (element as GroupElementType).children.some((child: ElementType) => checkPolotnoType(child, [polotnoTypes.Avatar]))
    ) {
        return true;
    }

    return false;
};

const getType = (element: ElementType): polotnoTypes => {
    if (element.type === polotnoTypes.Avatar || (element.type === polotnoTypes.Image && element.custom?.didType === polotnoTypes.Avatar)) {
        return polotnoTypes.Avatar;
    }

    return element.type as polotnoTypes;
};
